import React, { useEffect, useState } from 'react';
import { useActionSnackbar } from '../../contexts/ActionSnackbarContext'; // Changed to relative path

const ActionSnackbar: React.FC = () => {
  const { snackbarMessage, isSnackbarVisible, hideSnackbar } = useActionSnackbar();
  const [isVisibleInternal, setIsVisibleInternal] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (isSnackbarVisible) {
      setIsVisibleInternal(true);
      // Automatically hide after a short duration (e.g., 2 seconds)
      timer = setTimeout(() => {
        hideSnackbar();
      }, 2000);
    } else {
      // Allow fade-out animation before setting internal state to false
      const fadeOutTimer = setTimeout(() => {
        setIsVisibleInternal(false);
      }, 300); // Matches the duration of the fade-out animation
      return () => clearTimeout(fadeOutTimer);
    }

    return () => clearTimeout(timer);
  }, [isSnackbarVisible, hideSnackbar]);

  if (!isVisibleInternal && !isSnackbarVisible) {
    // Don't render if not visible and not in the process of fading out
    return null;
  }

  return (
    <div
      className={`
        fixed bottom-10 left-1/2 -translate-x-1/2 z-50
        px-4 py-2 rounded-md shadow-md
        bg-white dark:bg-gray-950
        text-gray-800 dark:text-gray-100
        text-sm
        transition-opacity duration-300 ease-in-out
        ${isSnackbarVisible ? 'opacity-100' : 'opacity-0'}
      `}
    >
      {snackbarMessage}
    </div>
  );
};

export default ActionSnackbar;
